import React, { useEffect, useState } from 'react';
import { Icon, Menu, MenuItem, MenuList, Typography, Popover } from '@mui/material';
import { size, get, set } from 'global/lib/lodash';
import { StyledListItemIcon, StyledPopper, Title, TriggerIcon } from './styles';
import { Button as OurButton } from '../Button';
import { guid, stopProp } from '../../utils';

export const MoreDrop = (props) => {
  const { options } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e, opt) => {
    setAnchorEl(null);
    opt.onClick && opt.onClick(e);
  };

  if (!size(options)) {
    return null;
  }

  return (
    <>
      <OurButton variant="text" color="secondary" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} data-testid={props['data-testid']}>
        <TriggerIcon>more_vert</TriggerIcon>
      </OurButton>
      <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {(options || []).map((opt, i) => {
          return (
            <MenuItem key={i} onClick={(e) => handleClose(e, opt)}>
              {opt.icon && (
                <StyledListItemIcon>
                  <Icon>{opt.icon}</Icon>
                </StyledListItemIcon>
              )}

              <Typography variant="inherit">{opt.title}</Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

const POPPERS = {};
const ELEMENTID = 'simple-popover';

export const MoreList = (props) => {
  const { options, icon, title } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [key] = useState(guid());

  const type = get(props, 'type', 'radio');

  const open = Boolean(anchorEl);

  const id = open ? ELEMENTID : undefined;

  const handleClick = (event) => {
    stopProp(event);
    if (!open) {
      Object.keys(POPPERS).map((k) => {
        const pop = POPPERS[k];
        pop && pop.forceClose && pop.forceClose();
      });
    }
    setAnchorEl(open ? undefined : event.currentTarget);
  };

  const forceClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (open) {
      props.onOpen && props.onOpen();
    } else {
      props.onClose && props.onClose();
    }
  }, [open]);

  useEffect(() => {
    set(POPPERS, key, { forceClose });
    return () => {
      set(POPPERS, key, undefined);
    };
  }, []);

  const handleClose = (e, opt) => {
    opt && opt.onClick && opt.onClick(e);
    if (opt && type === 'checkbox') {
      return;
    }
    onClose(e);
  };

  const onClose = (e) => {
    if (!props.preventClose) {
      setAnchorEl(null);
    }
  };

  if (!size(options)) {
    return null;
  }

  const getIcon = (opt) => {
    if (type === 'checkbox') {
      return <Icon>{opt.selected ? 'check_box' : 'check_box_outline_blank'}</Icon>;
    } else {
      return <Icon>{opt.selected ? 'radio_button_checked' : 'radio_button_unchecked'}</Icon>;
    }
  };

  const ELEM = props.preventClose ? StyledPopper : Popover;

  const buttonProps = get(props, 'buttonProps', {});

  const showIcon = get(props, 'showIcon', true);

  return (
    <>
      <OurButton
        color={props.color || 'secondary'}
        variant={props.variant || 'contained'}
        aria-controls="simple-menu"
        disableElevation
        size="small"
        aria-haspopup="true"
        onClick={handleClick}
        data-testid={props['data-testid']}
        {...buttonProps}
      >
        {props.renderButton ? props.renderButton() : <Icon>{icon || 'more_vert'}</Icon>}
      </OurButton>
      <ELEM id={id} anchorEl={anchorEl} open={open} onClose={onClose}>
        {!!title && (
          <Title onClick={handleClick}>
            {title}
          </Title>
        )}

        {/* MUI v9 MenuItem requires a MenuListContext ancestor (Menu or MenuList). */}
        {/* Popover/Popper don't provide it, so wrap here to avoid a WSOD crash. */}
        <MenuList disablePadding>
          {(options || []).map((opt, i) => {
            return (
              <MenuItem {...opt} key={i} onClick={(e) => handleClose(e, opt)}>
                {showIcon && <StyledListItemIcon>{getIcon(opt)}</StyledListItemIcon>}

                <Typography variant="inherit">{opt.title}</Typography>
              </MenuItem>
            );
          })}
        </MenuList>
      </ELEM>
    </>
  );
};

export const PopContainer = (props) => {
  const { icon, title } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [key] = useState(guid());

  const open = Boolean(anchorEl);

  const id = open ? ELEMENTID : undefined;

  const handleClick = (event) => {
    stopProp(event);
    if (!open) {
      Object.keys(POPPERS).map((k) => {
        const pop = POPPERS[k];
        pop && pop.forceClose && pop.forceClose();
      });
    }
    setAnchorEl(open ? undefined : event.currentTarget);
  };

  const forceClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (open) {
      props.onOpen && props.onOpen();
    } else {
      props.onClose && props.onClose();
    }
  }, [open]);

  useEffect(() => {
    set(POPPERS, key, { forceClose });
    return () => {
      set(POPPERS, key, undefined);
    };
  }, []);

  const onClose = (e) => {
    if (!props.preventClose) {
      setAnchorEl(null);
    }
  };

  const ELEM = props.preventClose ? StyledPopper : Popover;

  const buttonProps = get(props, 'buttonProps', {});

  return (
    <>
      <OurButton color={props.color || 'secondary'} variant={props.variant || 'contained'} aria-controls="simple-menu" disableElevation size="small" aria-haspopup="true" onClick={handleClick} {...buttonProps}>
        {props.renderButton ? props.renderButton() : <Icon>{icon || 'more_vert'}</Icon>}
      </OurButton>
      <ELEM id={id} anchorEl={anchorEl} open={open} onClose={onClose}>
        {!!title && (
          <Title onClick={handleClick}>
            {title}
          </Title>
        )}

        {props.children}
      </ELEM>
    </>
  );
};
